import { Box, Paper, Stack } from "@mui/material";
import { useIsSmallerScreen } from "../../utils/Functions";
import ConversationSidebar from "./components/ConversationSidebar";
import MessagesWindow from "./components/MessagesWindow";
import InboxMobile from "./mobile/InboxMobile";

export default function InboxPage() {
  const isSmallerScreen = useIsSmallerScreen();

  if (isSmallerScreen) {
    return (
      <Wrapper>
        <InboxMobile />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
        <ConversationSidebar />
        <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
          <MessagesWindow />
        </Box>
      </Box>
    </Wrapper>
  );
}

function Wrapper({ children }) {
  return (
    <Paper
      sx={{
        minHeight: "100vh",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <Stack mt={10} spacing={2} width={"100%"} sx={{ height: "90vh" }}>
        {children}
      </Stack>
    </Paper>
  );
}
